// @ts-nocheck
/* eslint-disable */
export const planeTakeOffIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 26 24"><path d="M13.66 6.216l-2.114-1.26a4 4 0 00-3.084-.428l-.048.012 2.45 2.425m4.587.821l5.04-1.35a1.74 1.74 0 012.13 1.23v0a1.74 1.74 0 01-1.23 2.13l-5.04 1.35-2.68 6.678a3 3 0 01-2.008 1.78l-.231.062 1.578-7.652-5.634 1.53a3 3 0 01-3.362-1.359L2.4 9.482l1.923-.515a1 1 0 011.007.303l.88.992 9.24-2.476zM3 23h20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'plane-take-off' as const,
};
